import {mock} from './index';

export default {
  getUserList: () => mock('/admin/user/list'),
  getGlobalUserList: () => mock('/admin/user/global/list'),
  userOrganizationJoin: () => mock('/admin/user/organization/join'),
  userOrganizationCreateAndJoin: () => mock('/admin/user/organization/createAndJoin'),
  removeUser: () => mock('/admin/user/organization/remove'),
  validateUser: () => mock('/admin/user/global/validate'),
  resetPassword: () => mock('/password/reset'),
  getUserDetail: () => mock('/admin/user/get'),
  triggerResetPassword: () => mock('/password/resetByEmail'),
  triggerRetrievePassword: () => mock('/password/retrieveByEmail'),
  modifyUser: () => mock('/admin/user/modify'),
  getAssignRoleList: () => mock('/admin/user/role/assignedList'),
  removeUserRole: () => mock('/admin/user/role/remove'),
  getWithAssignRoles: () => mock('/admin/user/role/list'),
  getWithAssignUserGroups: () => mock('/admin/user/userGroup/list'),
  assignUserRoles: () => mock('/admin/user/role/assign'),
  assignUserUserGroups: () => mock('/admin/user/userGroup/assign'),
  getAssignedUserGroupLists: () => mock('/admin/user/userGroup/assignedList'),
  removeUserGroup: () => mock('/admin/user/userGroup/remove'),
  getAssignStructureList: () => mock('/admin/user/structure/assignedList'),
  removeStructure: () => mock('/admin/user/structure/remove'),
  assignUserStructures: () => mock('/admin/user/structure/assign'),
  modifyPassword: () => mock('/password/modify'),
  getResetTokenInfo: () => mock('/password/reset/tokenInfo'),
  downloadUserTemplate: () => mock('/admin/user/import/template'),
  uploadUsersTemplate: () => mock('/admin/user/import'),
  downloadFailedRecord: () => mock('/admin/user/import/result'),
  uploadHistoryRecord: () => mock('/admin/user/import/history'),
  signalHistoryRecord: () => mock('/admin/user/import/info'),
  modifyUserProfile: () => mock('/user/profile/modify'),
  exportUser: () => mock('/admin/user/export'),
  getExportStatus: () => mock('/admin/user/export/status'),
  userExportDownload: () => mock('/admin/user/export/download'),
  getCurrentOperationsList: () => mock('/user/operation/list'),
  getDisplayConfig: () => mock('/admin/user/display-company-info'),
  getProfileInfo: () => mock('/user/profile/info')
  // getUserFilterList: () => mock('/admin/user/filter/list')
};
